import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, PageHeaderItem } from "../../../Components/Items";
import dayjs from "dayjs";

class Corredores extends Component {
  state = {
    todasCorredores: [],
    loading: false,
    modalAgregarCorredor: false,
    modalEditarCorredor: false,
    modalEditarCorredorId: null,
  }
  componentDidMount() {
    this.consultarCorredores();
  }

  consultarCorredores() {
    this.setState({loading: true})
    axios
    .post(
      "corredores/selectTodasCorredores",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.success === 2) {
          this.setState({
            todasCorredores: res.data.corredores.map((value) => {
              return {
                ...value,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
      }
    });
  }

  render() {
    const columns = [
      {
        title: "Numero",
        dataIndex: "numeroCorredor",
        key: "numeroCorredor",
        sorter: (a, b) => {
          if (a.numeroCorredor < b.numeroCorredor) {
            return -1;
          }
          if (a.numeroCorredor > b.numeroCorredor) {
            return 1;
          }
          return 0;
        },
        buscar: "numeroCorredor",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Correo",
        dataIndex: "correo",
        key: "correo",
        sorter: (a, b) => {
          if (a.correo < b.correo) {
            return -1;
          }
          if (a.correo > b.correo) {
            return 1;
          }
          return 0;
        },
        buscar: "correo",
      },
      {
        title: "Telefono",
        dataIndex: "telefono",
        key: "telefono",
        sorter: (a, b) => {
          if (a.telefono < b.telefono) {
            return -1;
          }
          if (a.telefono > b.telefono) {
            return 1;
          }
          return 0;
        },
        buscar: "telefono",
        responsive: ['lg'],
      },
      {
        title: "Fecha Nacimiento",
        dataIndex: "fechaNacimiento",
        key: "fechaNacimiento",
        sorter: (a, b) => {
          if (a.fechaNacimiento < b.fechaNacimiento) {
            return -1;
          }
          if (a.fechaNacimiento > b.fechaNacimiento) {
            return 1;
          }
          return 0;
        },
        render: (value) => dayjs(value).format('DD/MM/YYYY'),
        buscar: "fechaNacimiento",
        responsive: ['lg'],
      },
      {
        title: "Rama",
        dataIndex: "rama",
        key: "rama",
        sorter: (a, b) => {
          if (a.rama < b.rama) {
            return -1;
          }
          if (a.rama > b.rama) {
            return 1;
          }
          return 0;
        },
        render: (value) => value === 1 ? 'Varonil' : 'Femenil',
        buscar: "rama",
        responsive: ['lg'],
      },
      {
        title: "Fecha Registro",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        sorter: (a, b) => {
          if (a.fechaRegistro < b.fechaRegistro) {
            return -1;
          }
          if (a.fechaRegistro > b.fechaRegistro) {
            return 1;
          }
          return 0;
        },
        render: (value) => dayjs(value).format('DD/MM/YYYY'),
        buscar: "fechaRegistro",
        responsive: ['lg'],
      },
    ];
    return (
      <>
        <PageHeaderItem
          title="Corredores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <TableItem
        loading={this.state.loading}
          size="small"
          dataSource={this.state.todasCorredores}
          columns={columns}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(Corredores);